export default function PHP_debug_print_backtrace() {
  return (
    <div>
      <h1>PHP_debug_print_backtrace</h1>
    </div>
  );
}
